import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { CoreModule } from './core/core.module';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app/app.component';
import { MatIconRegistry } from '@angular/material/icon';
import { HttpClientModule } from '@angular/common/http';
import { UserService } from './global/services/user.service';
import { StoreModule } from '@ngrx/store';
import { AppEffects } from './state/app.effects';
import { EffectsModule } from '@ngrx/effects';
import { appReducer } from './state/app.reducer';
import { SessionService } from './global/services/session.service';
import { UserResolverService } from './global/services/user-resolver.service';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from './global/services/auth.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SharedModule } from './shared/shared.module';
import { SubscriptionService } from './global/services/subscription.service';
import { Apollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular-link-http';
import { GraphqlModule } from './graphql.module';
import { environment } from '../environments/environment';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { QuillModule } from 'ngx-quill';
import Counter from './counter';
import { MarkdownService } from './markdown/markdown.service';
import { MarkdownModule, MarkedOptions, MarkedRenderer } from 'ngx-markdown';
import { NgxLinkPreviewModule } from 'ngx-link-preview';
import { UserSubscriptionService } from './global/services/user-subscription.service';
import { TrendingModule } from './home/trending/trending.module';
import { SignUpGuard } from './global/guards/sign-up-guard.service';
import { CountryService } from './global/services/country.service';
import { HomeGuardService } from './global/guards/home-guard.service';
import { ImageLoaderModule } from './image-loader/image-loader.module';
import { Cloudinary as CloudinaryCore } from 'cloudinary-core';
import { CloudinaryModule } from '@cloudinary/angular-5.x';
import { FileUploadModule } from 'ng2-file-upload';
import { MatVideoModule } from 'mat-video';

// function that returns `MarkedOptions` with renderer override
export function markedOptionsFactory(): MarkedOptions {
  const renderer = new MarkedRenderer();

  renderer.link = (text: string) => {
    if (text.startsWith('mention')) {
      const handle = text.split('/')[3] || '';
      return `<a class="mentionlink" href="/${handle}">@${handle}</a>`;
    }

    if (text.startsWith('hashtag')) {
      const hash = text.split('/')[3] || '';
      return `<a class="hashtagLink" href="/hashtag/${hash}">#${hash}</a>`;
    }

    return `<a class="normal-url" target="_blank" href="${text}" >${text}</a>`;
  };

  return {
    renderer: renderer,
    gfm: true,
    breaks: false,
    pedantic: false,
    smartLists: true,
    smartypants: false
  };
}

export const cloudinary = {
  Cloudinary: CloudinaryCore
};

@NgModule({
  imports: [
    // angular
    BrowserAnimationsModule,
    BrowserModule,

    // core
    CoreModule,

    // app
    AppRoutingModule,

    GraphqlModule,
    // ApolloModule,
    // HttpLinkModule,

    HttpClientModule,

    // data modules
    EffectsModule.forFeature([AppEffects]),

    StoreModule.forFeature('app', appReducer),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: environment.production // Restrict extension to log-only mode
    }),

    MatProgressSpinnerModule,
    SharedModule,
    QuillModule.forRoot({
      customModules: [
        {
          implementation: Counter,
          path: 'modules/counter'
        }
      ],
      customOptions: [
        {
          import: 'formats/font',
          whitelist: [
            'mirza',
            'roboto',
            'aref',
            'serif',
            'sansserif',
            'monospace'
          ]
        }
      ]
    }),
    MarkdownModule.forRoot({
      markedOptions: {
        provide: MarkedOptions,
        useFactory: markedOptionsFactory
      }
    }),
    NgxLinkPreviewModule,
    TrendingModule,
    ImageLoaderModule.forRoot(),
    CloudinaryModule.forRoot(cloudinary, {
      cloud_name: 'gscroll',
      api_key: '346352577752652',
      api_secret: 'XG9mmUg8ywC38sFSHALbXdVtA5k',
      upload_preset: 'ecdak8ku'
    }),
    FileUploadModule
  ],
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  providers: [
    SubscriptionService,
    UserService,
    SessionService,
    UserResolverService,
    CookieService,
    UserSubscriptionService,
    AuthService,
    MarkdownService,
    { provide: Window, useValue: window },
    SignUpGuard,
    CountryService,
    HomeGuardService
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class AppModule {
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    apollo: Apollo,
    httpLink: HttpLink
  ) {
    // const webSocketLink = new WebSocketLink({
    //   uri: `ws://localhost:4200/sockjs-node/993/sfrgzlv4/websocket`,
    //   options: {
    //     reconnect: true,
    //     lazy: true
    //   }
    // });
    //
    //
    // const httpUrlLInk = httpLink.create({
    //   uri: environment.BASE_URL + '/api'
    // });
    //
    //
    // const loggingHttpLink = concat((operation: Operation, forward?: NextLink) => {
    //   console.log('LOG', operation);
    //   return forward(operation);
    // }, httpUrlLInk);
    //
    // const link = split(
    //   ({ query }) => {
    //     const { kind, operation } = getMainDefinition(query) as OperationDefinitionNode;
    //     return kind === 'OperationDefinition' && operation === 'subscription';
    //   },
    //   webSocketLink,
    //   loggingHttpLink);
    //
    // apollo.create({
    //   link,
    //   cache: new InMemoryCache()
    // });
  }
}
